
import { Helmet } from 'react-helmet-async';

interface ServiceSchemaProps {
  serviceName: string;
  description: string;
  provider: string;
  areaServed?: string;
  serviceType?: string;
}

export const ServiceSchema = ({ 
  serviceName, 
  description, 
  provider, 
  areaServed,
  serviceType = "Professional Employer Organization"
}: ServiceSchemaProps) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    "name": serviceName,
    "description": description,
    "serviceType": serviceType,
    "provider": {
      "@type": "Organization",
      "name": provider,
      "url": "https://thepeoapp.com"
    },
    ...(areaServed && {
      "areaServed": {
        "@type": "State",
        "name": areaServed
      }
    }),
    "offers": {
      "@type": "Offer",
      "description": "Professional Employer Organization matching service"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};
